/** @typedef {Record<string, string | Record<string, unknown>>} LocaleTree */
/** @type {LocaleTree} */
const es = {
  app: {
    defaultDocTitle: "peplies consult - Sports Marketing Consultants",
  },
  nav: {
    about: "Sobre nosotros",
    hallOfFame: "Salón de la fama",
    services: "Servicios",
    servicesAthletes: "Servicios para deportistas",
    servicesCompanies: "Servicios para empresas",
    references: "Referencias",
    refAthletes: "Referencias deportistas",
    refCompanies: "Referencias empresas",
    press: "Prensa",
    campaigns: "Campañas",
    campaignsPrint: "RP | Impreso | Cartel",
    campaignsTv: "Anuncios de TV",
    publications: "Publicaciones",
    scientificAdvisoryBoard: "Consejo científico",
    toggleMenu: "Alternar menu de navegacion",
  },
  auth: {
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    password: "Contraseña",
    passwordPlaceholder: "Introducir contraseña",
    wrongPassword: "Contraseña incorrecta",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    notice: "Este inicio de sesion del lado del cliente solo protege la visibilidad de navegacion y no es una autenticacion segura.",
    unavailable: "El inicio de sesion no esta disponible porque no hay una contrasena configurada.",
  },
  footer: {
    linksHeading: "ENLACES",
    about: "Sobre nosotros",
    services: "Servicios",
    contact: "Contacto",
    legal: "Aviso legal",
    privacy: "Politica de privacidad",
    servicesBlockHeading: "SERVICIOS",
    servicesAthletes: "Servicios para deportistas",
    servicesCompanies: "Servicios para empresas",
    rights: "Todos los derechos reservados.",
    companyName: "peplies consult GmbH",
    companyStreet: "Höhenstraße 12",
    companyPostalCode: "65321",
    companyCity: "Heidenrod",
    copyrightBrand: "peplies consult - Sports Marketing Consultants",
  },
  intro: {
    title: "Sobre nosotros",
    p1: 'Somos los «Consultants of Choice» para deportistas, clubes, federaciones y empresas nacionales e internacionales en el ámbito del marketing deportivo y el patrocinio deportivo.',
    p2: "Como empresa hermana de peplies consult - Marketing Consultants y peplies consult - Executive Consultants, y como socio de facultades universitarias líderes en economía del deporte, derecho deportivo y medicina deportiva, estamos comprometidos con la práctica y con la ciencia.",
    p3: "Nos medimos por la satisfacción de nuestros clientes y por nuestra contribución a la economía, al deporte y a la sociedad.",
    contactCta: "Contacto",
  },
  servicesSection: {
    title: "Servicios",
    subtitle: "Nuestros servicios de un vistazo.",
    athletesTitle: "Servicios para deportistas",
    athletesBody:
      'Para nuestros deportistas ofrecemos —también con la participación de socios y redes asociadas— todas las medidas de una atención integral al más alto nivel cualitativo («programa de 18 puntos»). Contamos con referencias internacionales especialmente en todos los ámbitos de los deportes de invierno (esquí alpino, biatlón, salto en esquí, combinado nórdico, bobsleigh, luge) así como en tenis, golf, equitación y atletismo.',
    companiesTitle: "Servicios para empresas",
    companiesBody:
      "Para empresas que ya realizan patrocinio deportivo ofrecemos medidas de análisis, control y optimización de sus conceptos de patrocinio y de los proyectos correspondientes, así como medidas de apoyo; para empresas que planean entrar en el patrocinio deportivo ofrecemos estudios de mercado y desarrollo de conceptos. Nuestros servicios incluyen: conceptos de patrocinio deportivo, estudios de mercado y controlling, medidas de apoyo así como scouting y adquisición de deportistas.",
  },
  clients: {
    title: "Empresas — comercialización de derechos deportivos / patrocinio deportivo",
  },
  contact: {
    docTitle: "peplies consult - Contacto",
    modalTitle: "Contacto",
    logoAlt: "peplies consult",
    close: "Cerrar",
    callUs: "Llámenos:",
    writeUs: "Escríbanos:",
    mailUs: "Envíenos un correo:",
    country: "Alemania",
    companyName: "peplies consult GmbH",
    street: "Höhenstraße 12",
    postalCode: "65321",
    city: "Heidenrod",
  },
  privacy: {
    docTitle: "peplies consult - Política de privacidad",
    title: "Política de privacidad",
  },
  legal: {
    docTitle: "peplies consult - Aviso legal",
    title: "Aviso legal",
    tmgaHeading: "Información según el § 5 TMG (Alemania)",
    country: "Alemania",
    contact: "Contacto",
    vatHeading: "Número fiscal / IVA",
    taxNumberLine: "Número fiscal (Steuernummer) 043 241 09523, oficina fiscal (Finanzamt) Wiesbaden II",
    vatIntro: "Número de identificación fiscal según el § 27 a de la ley alemana del IVA:",
    managingDirector: "Socio gerente",
    registerHeading: "Inscripción en el registro mercantil",
    registerCourtLabel: "Tribunal registral:",
    registerCourt: "Juzgado local de Wiesbaden (Amtsgericht Wiesbaden)",
    registerNumberLabel: "Número de registro:",
    responsibleHeading: "Responsable del contenido según el § 18 MStV (Alemania):",
  },
  athletesPage: {
    docTitle: "peplies consult - Deportistas",
    title: "Deportistas actuales",
    subtitle: "Deportistas para quienes peplies consult GmbH tiene o tuvo la responsabilidad de comercialización:",
  },
  athleteDetail: {
    docTitle: "peplies consult - Sports Marketing Consultants",
    notFound: "Deportista no encontrado",
    birthday: "Fecha de nacimiento:",
    discipline: "Disciplina:",
    club: "Club:",
    interests: "Intereses:",
    profession: "Profesión:",
    hobby: "Afición:",
    achievements: "Logros:",
    photoCredit: "Foto: ",
  },
  companyReferences: {
    docTitle: "peplies consult - Empresas — derechos deportivos / patrocinio deportivo",
    title: "Empresas — comercialización de derechos deportivos / patrocinio deportivo",
    pageIntro: "Seleccion de empresas que colaboran o han colaborado con peplies consult GmbH:",
    reference: "Referencia",
  },
  hallOfFame: {
    docTitle: "peplies consult - Salón de la fama",
    title: "Salón de la fama",
    subtitle:
      '"Leyendas del deporte" o proyectos para los que peplies consult GmbH tuvo o tiene responsabilidad de comercializacion:',
    achievementsHeading: "Logros destacados",
    noAchievements: "Sin logros registrados.",
    flipHint: "Pasa el cursor o toca para girar",
  },
  press: {
    docTitle: "peplies consult - Prensa",
    title: "Prensa",
    pageIntro: "Seleccion de reportajes sobre peplies consult GmbH:",
    openHint: "Haga clic para abrir",
    unavailable: "Este documento no esta disponible actualmente.",
    categories: {
      olympics: "Juegos Olímpicos",
      magazine: "Revista",
      news: "Noticias",
    },
  },
  publications: {
    docTitle: "peplies consult - Publicaciones",
    title: "Publicaciones",
    pageIntro: "Publicaciones en las que peplies consult GmbH ha colaborado:",
    isbn: "ISBN",
    openPdf: "Abrir PDF",
    openImage: "Ampliar imagen",
    empty: "El contenido de publicaciones se esta preparando.",
  },
  scientificAdvisoryBoard: {
    docTitle: "peplies consult - Consejo científico",
    title: "Consejo científico",
    sections: {
      sportsEconomics: {
        title: "Economía del deporte",
        members: [
          "Prof. Dr. Herbert Woratschek Universidad de Bayreuth",
          "Prof. Dr. Michael Wehrheim (fallecido) Universidad de Marburgo, European Business School (EBS) Oestrich-Winkel",
          "Prof. Dr. Guido Schafmeister Universidad Macromedia de Medios y Comunicación de Múnich",
        ],
      },
      sportsMedicine: {
        title: "Medicina del deporte/Ciencias del deporte/Teoría del entrenamiento/Medicina complementaria",
        members: [
          "Prof. Dr. Dieter Lazik Universidad de Potsdam, Universidad de Luxemburgo",
          "Prof. Dr. Hartmut Schröder Universidad Viadrina, Frankfurt/Oder",
          "Dr. Inge Gerding Bad Wildungen",
        ],
      },
    },
  },
  printCampaign: {
    docTitle: "peplies consult - RP, Impreso, Cartel",
    title: "RP | Impreso | Carteles",
    empty: "El material de campana se publicara pronto aqui.",
    galleryIntro:
      "Seleccion de campanas de comunicacion clasicas planificadas y realizadas por peplies consult GmbH:",
    imageSectionTitle: "Campanas de imagen",
    pdfSectionTitle: "Campanas PDF",
    items: "elementos",
    openImage: "Abrir imagen:",
    openPdf: "Abrir PDF:",
    openPdfCta: "Abrir PDF en una nueva pestana",
  },
  tv: {
    docTitle: "peplies consult - Anuncios de TV",
    title: "Anuncios de TV",
    subtitle:
      "Selección de campañas de TV planificadas y realizadas por peplies consult GmbH:",
    videoNotSupported: "Su navegador no admite la etiqueta de vídeo.",
  },
  athleteServices: {
    docTitle: "peplies consult - Servicios para deportistas",
    title: "Servicios para deportistas",
    intro:
      'Para nuestros deportistas ofrecemos —también con la participación de socios y redes asociadas— todas las medidas de una atención integral al más alto nivel cualitativo («programa de 18 puntos»). Contamos con referencias internacionales especialmente en todos los ámbitos de los deportes de invierno (esquí alpino, biatlón, salto en esquí, combinado nórdico, bobsleigh, luge) así como en tenis, golf, equitación y atletismo.',
  },
  companyServices: {
    docTitle: "peplies consult - Servicios para empresas",
    title: "Servicios para empresas",
  },
  cookie: {
    message:
      "Guardamos ajustes en su navegador (almacenamiento local). Con « Aceptar todas », los videos se cargan desde Cloudinary (EE. UU.); su IP puede transmitirse. Vea la politica de privacidad.",
    acceptAll: "Aceptar todas",
    acceptNecessary: "Solo necesarias",
    decline: "Rechazar",
    reopenSettings: "Cambiar ajustes de cookies",
    externalMediaBlocked:
      "Videos externos desactivados. Use « Cambiar ajustes de cookies » y « Aceptar todas », o lea la politica de privacidad.",
  },
  language: {
    label: "Idioma",
    names: {
      de: "Deutsch",
      en: "English",
      fr: "Français",
      es: "Español",
    },
  },
  notFound: {
    docTitle: "peplies consult - Pagina no encontrada",
    message: "No se pudo encontrar la pagina solicitada.",
    home: "Volver al inicio",
  },
};

export default es;
